export class RequestPasswordReset {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.requestPasswordReset(payload);
  }
}

